@if (title) {
<h3 class="mt-0">{{ title }}</h3>
} @for (docIindex of indexes; track docIindex; let i = $index) {
<app-link (click)="setActive(i)" [ngClass]="{ '-active': docIindex.active }" [to]="docIindex.path">
  {{ docIindex.title }}
</app-link>
}
